import {EmptyControl, MaxLength, MinLength, NestedArray, Required} from '@hvlng/framework-bff/core';
import {HvlDateConverter} from '@hvlng/framework-bff/util';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('KovanHrPerEntityInfoAttributesModel')
export class PerEntityInfoAttributesModel {
    @EmptyControl()
    @JsonProperty('name', String, true)
    name: string = null;

    @EmptyControl()
    @JsonProperty('type', String, true)
    type: string = null;


}
